import * as React from 'react'
import { DataGrid } from '@mui/x-data-grid'
import {
  Box,
  Button,
  Chip,
  IconButton,
  Link,
  MenuItem,
  Paper,
  Select,
  Skeleton,
  Typography,
} from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { BackArrowIcon, GoToLiveIcon, } from '../../icons'
import { GlobalStyles } from '@mui/material'
import UniversitySummary from '../university-table/UniversitySummary'
// import universityReviewUserRows from './UniversityData/userdata';
import UserCommentModal from './CommentModal/UserCommentModal'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { fetchUniversitiesNames, fetchUniversity, fetchUniversityList } from '../../api/universityApi'
import { fetchLatestReviewComment } from '../../api/commentApi'
import { handlePreview } from '../CourseDetails/CourseDetailsForm'
import CommonTableFormat from '../common/CommonTableFormat'
import CommonFilterTab from '../common/CommonFilterTab'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { setPaginationFiled } from '../../containers/pagination-container/reducer/paginationSlice'
import CommonDataTable from '../common/CommonDataTable'
import { setFilterField } from '../../containers/filter-container/reducer/filterSlice'
import { defaultPaginationValues, filterTypeOptions, studentStatusList } from '../../utils/constant'
import { formatMultiQueryParams, jsonParserFormatter } from '../../utils/helperFunction'

const UniversityReviewUser = () => {
  const authSlice = useSelector(state=>state.auth)
  const filterSlice = useSelector(state=>state.filter?.filters)
  const LOCATION_FILTER = `filters:${window.location.pathname}`
  const dispatch = useDispatch()
  const location = useLocation()
  const [rows, setRows] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const navigate = useNavigate()
  const [searchText, setSearchText] = React.useState('')
  const [selectedStatus, setSelectedStatus] = React.useState('')
  const [openCommentModal, setOpenCommentModal] = React.useState(false)
  const [selectedRowId, setSelectedRowId] = React.useState(null)
  const [commentText, setCommentText] = React.useState('')
  const [rowCount, setRowCount] = React.useState(0);
  const [universitySuggestion,setUniversitySuggesion] = React.useState([])
  const [searchFilter,setSearchFilter] = React.useState({})  
  const [pageFilters, setPageFilters] =  React.useState(defaultPaginationValues);
  const [isRender,setIsRender] = React.useState(false)

  const handleFliterSliceChange = (values = {}, isReset = false) => {
      let isQuery = typeof values === "object" && Object.keys(values)?.length
      isQuery && dispatch(setFilterField({ pathname: LOCATION_FILTER, filters: JSON.stringify({ ...(isReset ? {} : pageFilters), ...defaultPaginationValues, ...values }) }))
  }

  const fetchUniversitySuggestionList = () => {
      fetchUniversitiesNames((result)=>setUniversitySuggesion(result?.map(item=>({...item,value:item?.label}))))
      .catch(err=>console.log("error:---",err))
}

  const handleOpenCommentModal = async (rowId, type = 'university') => {
    setSelectedRowId(rowId);
    setCommentText('');
    setOpenCommentModal(true);

    try {
      const latestComment = await fetchLatestReviewComment(type, rowId);
      setCommentText(latestComment || '');
    } catch (err) {
      setCommentText('');
    }
  };

  const handleSaveComment = () => {
    setRows((prev) =>
      prev.map((row) =>
        row.id === selectedRowId ? { ...row, comments: commentText } : row
      )
    )
    setOpenCommentModal(false)
  }

  React.useEffect(() => {
    setLoading(true)
    const multiFilter = formatMultiQueryParams(filterSlice[LOCATION_FILTER])
    fetchUniversityList(setRows,{...searchFilter,...multiFilter, isMultiFilter: true},true,false,setRowCount)
      .finally(() => setLoading(false))
  }, [filterSlice[LOCATION_FILTER], isRender])

  // handle extra filter tabs changes
  React.useEffect(() => {
    if (pageFilters?.page) {
      handleFliterSliceChange({ page: 0 })
    } else {
      setIsRender(!isRender)
    }
  }, [searchFilter])

  // parse page filters
  React.useEffect(() => {
    const values = jsonParserFormatter(filterSlice[LOCATION_FILTER])
    setPageFilters(values)
  }, [filterSlice[LOCATION_FILTER]])

    // initial load
    React.useEffect(()=>{
    fetchUniversitySuggestionList()
    },[])

  function getStatusClass(status) {
    switch (status) {
      case 'Approved':
        return 'status-live'
      case 'Draft':
        return 'status-draft'
      case 'Re-Sumbited':
        return 'status-draft'
      case 'Pending':
        return 'status-pending'
      case 'Rework':
        return 'status-deactivated'
      default:
        return ''
    }
  }
  const columns = [
    {
      field: 'sNo',
      headerName: 'S. No.',
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      // renderCell: (params) => {
      //   return rows?.findIndex((r) => r.id === params.row.id) + 1
      // },
    },
    {
      field: 'universityId',
      headerName: 'University ID',
      flex: 1,
      minWidth: 130,
      cellClassName: 'sticky-col-1',
      headerClassName: 'sticky-col-1',
      filterColumnName:"universityId",
      filterType:filterTypeOptions.string,
    },
    {
      field: 'name',
      headerName: 'University',
      flex: 2,
      minWidth: 220,
      filterColumnName:"universityName",
      filterType:filterTypeOptions.selection,
      selection:universitySuggestion,
      renderCell: (params) => {
        return loading ? (
          <Skeleton width={150} />
        ) : (<Box display="flex" alignItems="center" gap={1}>
          <Box
            component="img"
            src={params.row.logo}
            alt="logo"
            sx={{
              width: 40,
              height: 40,
              padding: '5px',
              borderRadius: '50%',
              objectFit: 'contain',
              backgroundColor: '#fff',
              boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
              display: 'block',
              maxHeight: 60,
            }}
          />
          {params.value}
        </Box>)
      }
      ,
    },
    {
      field: 'gotoLive',
      headerName: 'Preview',
      width: 100,
      filterable:false,
      renderCell: (params) =>
        loading ? (
          <Skeleton variant="circular" width={24} height={24} />
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', height: '100%' }}>
            <IconButton
              color="primary"
              onClick={() => handlePreview(params.row?.id, 'university')}
            >
              <GoToLiveIcon />
            </IconButton>
          </Box>
        ),
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      minWidth: 150,
      filterColumnName:"status",
      filterType:filterTypeOptions.selection,
      selection:studentStatusList,
      renderCell: (params) =>
        loading ? (
          <Skeleton width={70} />
        ) : (
          <Chip
            label={params.value}
            size="small"
            icon={
              <FiberManualRecordIcon
                className={getStatusClass(params.value)}
                sx={{
                  fontSize: 10,
                  color: getStatusColor(params.value),
                }}
              />
            }
            sx={{
              bgcolor: getStatusBgColor(params.value),
              color: getStatusTextColor(params.value),
              fontWeight: 500,
            }}
          />
        ),
    },

    { field: 'createdDate',
       headerName: 'Created Date', 
       width: 130,
      filterColumnName:"createdAt",
      filterType:filterTypeOptions.dateRange,
      },
    { field: 'lastUpdate', 
      headerName: 'Last Update', 
      width: 130,
      filterColumnName:"updatedAt",
      filterType:filterTypeOptions.dateRange,
    },

    {
      field: 'completion',
      headerName: 'Completion',
      flex: 1,
      width: 100,
      filterColumnName:"completionPercentage",
      filterType:filterTypeOptions.numberRange,
      renderCell: (params) => (
        <Box
          sx={{
            color: params.value >= 80 ? '#22c55e' : params.value >= 50 ? '#f59e0b' : '#098B34',
            fontWeight: 500,
            fontSize: '13px',
          }}
        >
          {params.value}%
        </Box>
      ),
    },
    {
      field: 'createdBy',
      headerName: 'Created By',
      flex: 1,
      width: 140,
      filterColumnName:"createdBy",
      filterType:filterTypeOptions.string,
      renderCell: (params) =>
        loading ? <Skeleton width={80} /> : params.value,
    },
    {
      field: 'reviewedBy',
      headerName: 'Reviewed By',
      flex: 1,
      minWidth: 130,
      filterColumnName:"reviewedBy",
      filterType:filterTypeOptions.string,
    },
    {
      field: 'comments',
      headerName: 'Comments',
      flex: 1,
      minWidth: 160,
      filterColumnName:"comments",
      filterType:filterTypeOptions.string,
      renderCell: (params) => {
        const rawStatus = params.row.status || ''
        const normalizedStatus = rawStatus.trim().toLowerCase()
        const isViewableStatus = ['rework'].includes(normalizedStatus)

        return (
          <Button
            size="small"
            variant="outlined"
            disabled={!isViewableStatus}
            sx={{ fontSize: '12px', textTransform: 'none' }}
            onClick={() =>
              isViewableStatus && handleOpenCommentModal(params.row.id, 'university')
            }
          >
            View
          </Button>
        )
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      filterable:false,
      width: 100, // fixed size for button
      renderCell: (params) => {
        const isEditable = ['Draft', 'Rework'].includes(params.row.status)
        return (
          <Button
            variant="contained"
            size="small"
            disabled={!isEditable}

            sx={{
              fontSize: '12px',
              textTransform: 'none',
              backgroundColor: isEditable ? '#0463EF' : '#ccc',
            }}
            onClick={() => navigate(`/user/university-listing-management/university-details/${params?.row?.universityId}`)}
          >
            Edit
          </Button>
        )
      },
    },
  ]



  function getStatusBgColor(status) {
    switch (status) {
      case 'Live':
        return '#fff'
      case 'Draft':
        return '#fff'
      case 'Rework':
        return '#fff'
      case 'Re-Sumbited':
        return '#fff'
      default:
        return '#fff'
    }
  }

  function getStatusTextColor(status) {
    switch (status) {
      case 'Live':
        return '#363853' // darker green
      case 'Draft':
        return '#363853' // darker gray
      case 'Rework':
        return '#363853' // darker orange
      case 'Re-Sumbited':
        return '#363853' // darker red
      default:
        return '#666'
    }
  }

  // Helper functions for status colors
  function getStatusColor(status) {
    switch (status) {
      case 'Approved':
        return '#22c55e' // green
      case 'Draft':
        return '#64748b' // grayish
      case 'Pending':
        return '#f97316' // orange
      case 'Rework':
        return '#f97316' // orange
      case 'Re-Sumbited':
        return '#ef4444' // red
      default:
        return '#999'
    }
  }

  const statusList = [
    { label: 'All University', count: 24 },
    { label: 'Pending Approval', count: 24 },
    { label: 'Approved', count: 24 },
    { label: 'Re-Sumbited', count: 24 },
    { label: 'Rework', count: 24 },
    { label: 'Draft', count: 10 },
  ]

  return (
    <>
      {/* Apply global styles to DataGrid dropdown menus */}
      <GlobalStyles
        styles={{
          '.MuiDataGrid-menuList': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiDataGrid-panelContent': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiSelect-select': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiList-root .MuiButtonBase-root': {
            fontSize: '13px',
          },
          '.MuiDataGrid-panelContent .MuiOutlinedInput-input': {
            fontSize: '13px',
          },
          '.MuiDataGrid-columnsManagement .MuiFormControlLabel-root .MuiFormControlLabel-label': {
            fontSize: '13px',
          },
          '.MuiDataGrid-menuList .MuiTypography-root': {
            fontSize: '13px',
          },
          '.MuiDataGrid-menuList .MuiMenuItem-root': {
            fontSize: '13px',
            padding: '6px 12px',
          },
          '.MuiDataGrid-menuList .MuiMenuItem-root:hover': {
            backgroundColor: '#f5f5f5',
          },
          '& .MuiDataGrid-columnHeaders': {
            position: 'sticky',
            top: 0,
            zIndex: 2,
            backgroundColor: '#fff',
          },
          '& .MuiDataGrid-cell.sticky-col-1': {
            position: 'sticky',
            left: 0,
            background: '#fff',
            zIndex: 2,
          },
          '& .MuiDataGrid-columnHeader.sticky-col-1': {
            position: 'sticky',
            left: 0,
            background: '#fff',
            zIndex: 3, // slightly higher than cell
          },
        }}
      />

      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', padding: '10px 15px', borderBottom: '1px solid #E6E7E8', background: '#fff', }}>
          <div className="row align-items-center">
            <div className="col">
              <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1, }}><Link href="/" className='d-flex'><BackArrowIcon /></Link>University Listing Management </Typography>
            </div>
            {/* End Col */}
            <div className="col">  <Box display="flex" gap={2} sx={{ justifyContent: 'end', }}>

              <Button onClick={() => navigate('/user/university-listing-management/university-details')} sx={{ background: '#0463EF', color: '#fff', minHeight: 'auto', padding: '4px 15px', fontSize: '14px', textTransform: 'capitalize', }}>
                Add University
              </Button>
            </Box></div>
          </div>
          {/* End Col */}
        </div>
        <UniversitySummary type="university" requestParams={{createdBy:authSlice?.user?._id}}/>
        {/* Filter Toolbar */}
        <CommonFilterTab type='university' module='student' searchPlaceholder='Search University...' detailType='University Details' fetchList={setSearchFilter} showCount={rows?.length} rowCount={rowCount} isStatus={true}/>

        {/* Data Table */}
        <CommonDataTable columns={columns} rows={rows} idKey="field" loading={loading} filterEnabled={true} rowCount={rowCount} 
        pageFilters={pageFilters}
        handleFliterSliceChange={handleFliterSliceChange}
         />
  
      </Box>

      <UserCommentModal
        open={openCommentModal}
        onClose={() => setOpenCommentModal(false)}
        onSave={handleSaveComment}
        commentText={commentText}
        setCommentText={setCommentText}
        mode='view'
      />
    </>
  )
}

export default UniversityReviewUser
